// Firestore-backed persistence for Avatar Chat settings per character
// Writes to: characters/{characterId}.avatar_chat_settings

import { doc, getDoc, setDoc } from 'firebase/firestore'
import { db } from '@/services/firebase/config'

function normalizeId(id) {
  return String(id || '').trim()
}

export async function saveForCharacter(characterId, payload) {
  const id = normalizeId(characterId)
  if (!id) return false
  try {
    const ref = doc(db, 'characters', id)
    const next = { ...(payload || {}) }
    if (typeof next.schemaVersion !== 'number') next.schemaVersion = 1
    if (typeof next.updatedAt !== 'number') next.updatedAt = Date.now()
    await setDoc(ref, { avatar_chat_settings: next }, { merge: true })
    return true
  } catch (err) {
    console.warn('[AvatarChat] saveForCharacter failed', err)
    return false
  }
}

export async function loadForCharacter(characterId) {
  const id = normalizeId(characterId)
  if (!id) return null
  try {
    const ref = doc(db, 'characters', id)
    const snap = await getDoc(ref)
    if (!snap.exists()) return null
    const data = snap.data() || {}
    const settings = data.avatar_chat_settings || null
    return settings && typeof settings === 'object' ? settings : null
  } catch (err) {
    console.warn('[AvatarChat] loadForCharacter failed', err)
    return null
  }
}
